import { toSentenceCase } from './toSentenceCase'

export function getLabel(labelRaw: string, label: string | undefined) {
    return label || toSentenceCase(labelRaw)
}
